module.exports = __webpack_public_path__ + "static/media/lnhs.fb1c1391.png";